import { create } from 'zustand';
import { api } from '../services/apiService';
import type { TranscriptEntry, TranscriptContent, SessionFile } from '../types/docs';

interface SessionsState {
  transcripts: TranscriptEntry[];
  selectedTranscript: TranscriptContent | null;
  sessionFiles: SessionFile[];
  transcriptsLoading: boolean;
  transcriptLoading: boolean;
  sessionFilesLoading: boolean;

  fetchTranscripts: () => Promise<void>;
  selectTranscript: (filename: string) => Promise<void>;
}

export const useSessionsStore = create<SessionsState>((set) => ({
  transcripts: [],
  selectedTranscript: null,
  sessionFiles: [],
  transcriptsLoading: false,
  transcriptLoading: false,
  sessionFilesLoading: false,

  fetchTranscripts: async () => {
    set({ transcriptsLoading: true });
    try {
      const transcripts = await api.get<TranscriptEntry[]>('/docs/transcripts');
      set({ transcripts, transcriptsLoading: false });
    } catch (err) {
      console.error('Failed to fetch transcripts:', err);
      set({ transcriptsLoading: false });
    }
  },

  selectTranscript: async (filename: string) => {
    set({ selectedTranscript: null, sessionFiles: [], transcriptLoading: true, sessionFilesLoading: true });

    try {
      const content = await api.get<TranscriptContent>(`/docs/transcripts/${filename}`);
      set({ selectedTranscript: content, transcriptLoading: false });
    } catch (err) {
      console.error('Failed to fetch transcript:', err);
      set({ transcriptLoading: false });
    }

    try {
      const files = await api.get<SessionFile[]>(`/docs/transcripts/${filename}/files`);
      set({ sessionFiles: files, sessionFilesLoading: false });
    } catch (err) {
      console.error('Failed to fetch session files:', err);
      set({ sessionFilesLoading: false });
    }
  },
}));
